<template>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <h1>404 - Not Found</h1>
        </v-col>
      </v-row>
    </v-container>
</template>